import React from 'react';
import { TableCell, TableRow, Typography, IconButton } from '@mui/material';
import { format } from 'date-fns';
import { he } from 'date-fns/locale';
import { Schema } from '../../../../../amplify/data/resource';
import EditIcon from '@mui/icons-material/Edit';

// @ts-ignore
type Coupon = Schema['Coupon']['type'];

interface CouponItemProps {
  coupon: Coupon;
  onEditClick: (coupon: Coupon) => void;
}

const getStatusText = (status: string) => {
  switch (status) {
    case 'ACTIVE':
      return 'פעיל';
    case 'DISABLED':
      return 'מושבת';
    case 'EXPIRED':
      return 'פג תוקף';
    case 'EXHAUSTED':
      return 'מוצה';
    default:
      return status;
  }
};

const getDiscountTypeText = (discountType: string) => {
  switch (discountType) {
    case 'PERCENT':
      return 'אחוז';
    case 'AMOUNT':
      return 'סכום';
    default:
      return discountType;
  }
};

const CouponItem: React.FC<CouponItemProps> = ({ coupon, onEditClick }) => {
  const formatDate = (dateString: string) => {
    try {
      return format(new Date(dateString), 'dd/MM/yyyy', { locale: he });
    } catch {
      return 'תאריך לא תקין';
    }
  };

  const formatDiscountValue = (value: number, type: string) => {
    if (type === 'PERCENT') {
      return `${value}%`;
    }
    return `₪${value}`;
  };

  return (
    <TableRow
    sx={{
      backgroundColor: '#F2F4F7',
      borderRadius: '10px',
      p: '20px',
      overflow: 'hidden',
      '&:last-child td, &:last-child th': { border: 0 },
      boxShadow: 'none',
      textAlign: 'right',
      cursor: 'pointer',
    }}
    >
      <TableCell sx={{ padding: '15px 20px', textAlign: 'right', borderTopRightRadius: '10px',
          borderBottomRightRadius: '10px', }}>
        <Typography
          fontSize="14px"
          fontWeight="600"
          fontFamily="AlmoniDL"
          color="#2E3A59"
        >
          {coupon.code}
        </Typography>
      </TableCell>

      <TableCell sx={{ padding: '15px 20px', textAlign: 'right' }}>
        <Typography
          fontSize="14px"
          fontWeight="700"
          fontFamily="AlmoniDL"
          color="#2E3A59"
        >
          {coupon.description || '-'}
        </Typography>
      </TableCell>

      <TableCell sx={{ padding: '15px 20px', textAlign: 'right' }}>
        <Typography
          fontSize="14px"
          fontWeight="700"
          fontFamily="AlmoniDL"
          color="#2E3A59"
        >
          {getDiscountTypeText(coupon.discountType || '')}
        </Typography>
      </TableCell>

      <TableCell sx={{ padding: '15px 20px', textAlign: 'right' }}>
        <Typography
          fontSize="14px"
          fontWeight="600"
          fontFamily="AlmoniDL"
          color="#2E3A59"
        >
          {formatDiscountValue(coupon.discountValue || 0, coupon.discountType || '')}
        </Typography>
      </TableCell>

      <TableCell sx={{ padding: '15px 20px', textAlign: 'right' }}>
        <Typography
          fontSize="14px"
          fontWeight="700"
          fontFamily="AlmoniDL"
          color="#2E3A59"
        >
          {coupon.startDate ? formatDate(coupon.startDate) : '-'}
        </Typography>
      </TableCell>

      <TableCell sx={{ padding: '15px 20px', textAlign: 'right' }}>
        <Typography
          fontSize="14px"
          fontWeight="700"
          fontFamily="AlmoniDL"
          color="#2E3A59"
        >
          {coupon.expirationDate ? formatDate(coupon.expirationDate) : '-'}
        </Typography>
      </TableCell>

      <TableCell sx={{ padding: '15px 20px', textAlign: 'right' }}>
        <Typography
          fontSize="14px"
          fontWeight="700"
          fontFamily="AlmoniDL"
          color="#2E3A59"
        >
          {coupon.usageLimit ? `${coupon.totalUses || 0}/${coupon.usageLimit}` : 'ללא מגבלה'}
        </Typography>
      </TableCell>

      <TableCell sx={{ padding: '15px 20px', textAlign: 'right' }}>
        <Typography
          fontSize="14px"
          fontWeight="700"
          fontFamily="AlmoniDL"
          color="#2E3A59"
        >
          {getStatusText(coupon.status || '')}
        </Typography>
      </TableCell>

      {/* פעולות */}
      <TableCell sx={{ 
        padding: '15px 20px', 
        textAlign: 'right',
        borderTopLeftRadius: '10px',
        borderBottomLeftRadius: '10px',
      }}>
        <IconButton
          onClick={() => onEditClick(coupon)}
          sx={{
            color: '#2E3A59',
            '&:hover': {
              backgroundColor: 'rgba(46, 58, 89, 0.1)',
            },
          }}
          size="small"
        >
          <EditIcon fontSize="small" />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export default CouponItem; 